import { assistantThreadDeepLinkPath } from '../../paths';

/**
 * Where a journal entry's source-thread link points. The thread belongs to the
 * entry's actor, not to the member whose memory pane is open — a household
 * memory can be written from any caregiver's session, and the thread inspector
 * scopes its rail and bulk actions to the user the link names.
 */
export function journalThreadLinkPath(
  entry: { sourceThreadId: string; actorUserId?: string | null },
  pane: { userId: string | null; familyId: string }
): string {
  return assistantThreadDeepLinkPath({
    // Both can be absent — a household row whose writer's account is gone
    // carries no user id, and the journal's own actor column has no FK to
    // restore one. `threadId` alone still opens the transcript; what is lost is
    // the left-hand thread list, which needs a member to populate.
    userId: entry.actorUserId ?? pane.userId ?? undefined,
    familyId: pane.familyId,
    threadId: entry.sourceThreadId,
  });
}
